export const BALANCE_REFRESH = 'BALANCE_REFRESH';

export function balanceRefresh() {
  return {
    type: BALANCE_REFRESH,
  };
}
